import { z } from 'zod';

export function useOpuSearchFormSchema() {
  return z.object({
    dishType: z.string().min(1, { message: 'Dish Type is required' }),
    ivmTechTime: z.string().min(1, { message: 'IVM Tech Time is required' }),
    gradeABC: z.number({ required_error: 'Grade ABC is required' }),
    gradeD: z.number({ required_error: 'Grade D is required' }),
    gradeE: z.number({ required_error: 'Grade E is required' }),
    dead: z.number({ required_error: 'Dead count is required' }),
    total: z.number({ required_error: 'Total is required' }),
    numInMat: z.number({ required_error: 'Number in Mat is required' }),
    comments: z.string(),
    fertPlan: z.string().min(1, { message: 'Fert Plan is required' }),
    ivmCyto: z.number({ required_error: 'Dead count is required' }),
    usdaSeal: z.string(),
  });
}

export type OpuSearchFormValues = z.infer<
  ReturnType<typeof useOpuSearchFormSchema>
>;

export const qcDataSchema = z.object({
  tog_qc_hepdate: z.date(),
  tog_qc_matdate: z.date(),
  tog_qc_opuholdingdate: z.date().optional(),
  tog_qc_opuholding: z.string(),
  tog_qc_opuflushdate: z.date(),
  tog_qc_opuflush: z.string().min(1, 'Required'),
  tog_qccomment: z.string().optional(),
  tog_qc_slide_warmer: z.string().min(1, 'Required'),
  tog_qc_tokai_hit: z.string().min(1, 'Required'),
  tog_qc_water_bath_temperature: z.string().min(1, 'Required'),
  tog_qcairqualityint: z.number().min(0, 'Required'),
  tog_qc_cellstrainer: z.string().min(1, 'Required'),
  tog_qc_fiftymllotno: z.string().min(1, 'Required'),
  tog_qc_thirtymlsyringe: z.string().min(1, 'Required'),
  tog_qc_tenmlsyringe: z.string().min(1, 'Required'),
  tog_qc_fiftymltubetype: z.string().min(1, 'Required'),
  tog_qc_rinsemedialotdate: z.date(),
  tog_qc_incubatorno: z.string().min(1, 'Required'),
  qcFreezetemp: z.string().min(1, 'Required'),
});

export type QcDataSchema = z.infer<typeof qcDataSchema>;
